import { useAuth0 } from '@auth0/auth0-react';

import config from '../../../config';

interface FooterHelpProps {
  align?: 'center' | 'left';
}

const FooterHelp = ({ align = 'center' }: FooterHelpProps) => {
  const { logout } = useAuth0();

  const handleSignOut = () => {
    if (config.isLogycaFlavor) {
      window.location.href = config.REACT_APP_LOGYCA_LOGIN_URL;
    } else {
      logout({ returnTo: `${window.location.origin}` });
    }
  };

  return (
    <div
      className={`flex items-center gap-5 flex-wrap text-[13px] text-gray-500 mt-1 ${
        align === 'center' ? 'justify-center' : 'justify-start'
      }`}>
      <button
        type="button"
        onClick={handleSignOut}
        className="text-gray-500 hover:underline cursor-pointer bg-transparent border-none text-[13px]">
        Sign out
      </button>
    </div>
  );
};

export default FooterHelp;
